define('user-menu',['loader', 'jquery', 'angular', 'angular-ui-bootstrap', 'menu-invitations', 'menu-organizations'], function (loader, $, ng) {
    'use strict';

    //--------------------------------------------------------------[ User Menu Controller
    var userMenu = ng.module('userMenu', ['ui.bootstrap', 'signup.menuInvitations', 'signup.menuOrganizations']);

    userMenu.controller('UserMenuCtrl', ['$scope', '$timeout', function ($scope, $timeout) {
        $scope.menu = {
            open: false
        };
    }]);
});

